<template>
<base-modal size="xl" hide-footer hide-header no-padding>
    <div class="trip-results" style="height:60vh !important; position: relative" @click.stop="">
        <!-- Map for showing trip here -->
        <map-container
            ref="mapContainer"
            :find-user="false"
            @onDragEnd="dragEnd"
            @onMapChanged="mapChanged"
        />
        <trip-map
            v-if="map && mapTrip"
            ref="tripMap"
            :trip-item="mapTrip"
            :map="map"
            :show-end-points="selectedReportType === 5"
            @routePartSelected="onRouteSelected"
        />
    </div>
    <div v-if="isMaterialReport" class="px-2"  @click.stop="">
        <div v-for="(item, index) in materialReports" :key="index">
            <div class="row">
                    <div class="col-10">
                        <div class="row">
                            <span class="span-title">
                                {{ $t('spreader_data.dry_material') }}
                            </span>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <span class="search-title ">{{ $t('spreader_data.materials') }}</span>
                                <spreader-material-selector
                                    :materialType="materialTypes.DRY"
                                    @onMaterialSelection="value => item.materialReportDryMaterial = value ? value.material : value"
                                />
                            </div>
                            <div class="col-3">
                                <span class="search-title ">{{ $t('spreader_data.amountWithoutUnit') }}</span>
                                <input
                                    id="amount"
                                    v-model="item.materialReportDryAmount"
                                    type="number"
                                    step="any"
                                    class="form-control form-control-sm no-margin"
                                />

                            </div>
                            <div class="col-3">
                                <span class="search-title ">{{ $t('spreader_data.unit') }}</span>
                                <select
                                    id="unit"
                                    v-model="item.materialReportDryUnit"
                                    class="form-select form-select-sm no-margin"
                                >
                                    <option
                                        v-for="option in options"
                                        :key="option.value"
                                        :value="option.value"
                                    >
                                        {{ option.text }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <span class="span-title">
                                {{ $t('spreader_data.liquid_material') }}
                            </span>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <span class="search-title ">{{ $t('spreader_data.materials') }}</span>
                                <spreader-material-selector
                                    :materialType="materialTypes.LIQUID"
                                    @onMaterialSelection="value => item.materialReportLiquidMaterial = value ? value.material : value"
                                />
                            </div>
                            <div class="col-3">
                                <span class="search-title ">{{ $t('spreader_data.amountWithoutUnit') }}</span>
                                <input
                                    id="amount"
                                    v-model="item.materialReportLiquidAmount"
                                    type="number"
                                    step="any"
                                    class="form-control form-control-sm no-margin"
                                />
                            </div>
                            <div class="col-3">
                                <span class="search-title ">{{ $t('spreader_data.unit') }}</span>
                                <select
                                    id="unit"
                                    v-model="item.materialReportLiquidUnit"
                                    class="form-select form-select-sm no-margin"
                                >
                                    <option
                                        v-for="option in options"
                                        :key="option.value"
                                        :value="option.value"
                                    >
                                        {{ option.text }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <hr/>
                    <div class="col-2 mt-auto">
                        <button class="btn btn-sm btn-danger m-1" :disabled="materialReports.length <= 1" @click.stop="removeMaterialReport(index)">
                            <i class="fa fa-trash" style="font-size: .8em; padding: 0; line-height: 1em;"/>
                        </button>
                        <button class="btn btn-sm btn-success m-1" @click.stop="addMaterialReport">
                            <i class="fa fa-plus" style="font-size: .8em; padding: 0; line-height: 1em;"/>
                        </button>
                    </div>
                </div>
            <hr v-if="index < (materialReports.length - 1)"/>
        </div>
    </div>

    <div class="col-12 d-flex justify-content-end p-3" @click.stop="">
        <button class="btn btn-secondary form-button" @click="closeModal">
            {{ $t('common.close') }}
        </button>
        <button v-if="isMaterialReport" :disabled="!isSomeMaterialSelected || loading"  class="btn btn-success form-button" @click="sendMaterialReports">
            {{ $t('common.add') }}
        </button>
    </div>
    <div
        v-if="loading"
        id="loader"
        class="spinner"
    ></div>
</base-modal>
</template>

<script>
import MapContainer from "@/components/map/MapContainer.vue";
import TripMap from "@/components/trip/TripMap.vue";
import {contractReportTypes} from "@/components/mixins/ContractMixin";
import SpreaderMaterialSelector from "@/components/materials/spreaderdata/SpreaderMaterialSelector.vue";
import {spreaderDataMixin} from "@/components/mixins/SpreaderDataMixin";
import {restApi} from "@/components/mixins/RestApiMixin";
import BaseModal from "@/components/BaseModal";
import {inject} from "vue";

export default {
    name: "ContractModal",
    components: {BaseModal, SpreaderMaterialSelector, TripMap, MapContainer},
    mixins: [restApi, spreaderDataMixin],
    props: {
        mapVisible: {
            type: Boolean,
            default: false
        },
        mapTripId: {
            type: Number,
            default: null
        },
        selectedReportType: {
            type: Number,
            default: null
        },
        results: {
            default: null
        }
    },
    data: function () {
        return {
            loading: false,
            materialReports: [],
            map: null,
            mapTrip: null,
            selectedRoutePoints: null,
            data: {},
            alertDismissSecs: 5,
            alertDismissCountDown: 0,
            variant: 'danger',
            alertMessage: ''
        }
    },
    computed: {
        isMaterialReport() {
            return this.selectedReportType === contractReportTypes.REPORT_MATERIAL
        },
        isSomeMaterialSelected() {
            return this.materialReports.some(item => item.materialReportDryMaterial || item.materialReportLiquidMaterial)
        },
        options() {
            return this.supportedRoutaUnits()
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    mounted() {
        this.addMaterialReport()
    },
    methods: {

        onRouteSelected(route) {
            this.selectedRoutePoints = route
        },

        dragEnd(data) {
            if (this.$refs.tripMap) {
                this.$refs.tripMap.onDragEnd(data)
            }
        },

        sendMaterialReports() {
            this.loading = true
            let trip = JSON.parse(JSON.stringify(this.mapTrip))
            trip.geometry = this.selectedRoutePoints
            const data = {
                materialReports: this.materialReports,
                trip: trip
            }
            this.restAdd(this.spreaderDataAddToRoutaUrl, data, (response) => {
                    this.loading = false
                    // If status is 206, it means that some of the materials are not sent to Harja successfully
                    if(response.status === 206) {
                        this.showAlert(this.$t('spreader_data.alert_materials_add_partial_success'), 'warning')
                    } else {
                        this.showAlert(this.$t('spreader_data.alert_materials_add_success'), 'success')
                    }
                    this.resetMaterialReports()
                },
                () => {
                    this.loading = false
                    this.showAlert(this.$t('spreader_data.alert_materials_add_fail'))
            })
        },

        closeModal() {
            this.$emit('close')
            this.resetMaterialReports()
        },

        resetMaterialReports() {
            this.materialReports = []
            this.addMaterialReport()
        },

        addMaterialReport() {
            const material = this.createNewMaterialReport(null, 0, null, null, 0, null)
            this.materialReports.push(material)
        },

        removeMaterialReport(index) {
            this.materialReports.splice(index, 1)
        },

        createNewMaterialReport(materialDry, dryAmount, dryUnit, materialLiquid, liquidAmount, liquidUnit) {
            return {
                materialReportDryMaterial: materialDry,
                materialReportDryAmount: dryAmount,
                materialReportDryUnit: dryUnit,
                materialReportLiquidMaterial: materialLiquid,
                materialReportLiquidAmount: liquidAmount,
                materialReportLiquidUnit: liquidUnit
            }
        },

        mapChanged(map) {
            this.map = map
            this.map.resizeMap()
            this.mapTrip = this.results.find(item => item.id === this.mapTripId)
            this.selectedRoutePoints = this.mapTrip.geometry
        },
        showAlert: function (message, variant) {
            this.alertDismissCountDown = this.alertDismissSecs
            this.alertMessage = message
            if (variant) {
                this.variant = variant
            } else {
                this.variant = 'danger'
            }
        },
        alertCountDownChanged(dismissCountDown) {
            this.alertDismissCountDown = dismissCountDown
        },
    }
}
</script>

<style scoped>
.nooverflow {
    overflow: hidden;
}
</style>
